import { create } from 'zustand'

import { api } from '@/api/client'

import { logoutSession, refreshSession } from './webSession'

type Me = NonNullable<Awaited<ReturnType<typeof loadMe>>>

async function loadMe() {
  const { data } = await api.GET('/api/v1/me')
  return data ?? null
}

interface SessionState {
  status: 'idle' | 'loading' | 'authenticated' | 'anonymous'
  me: Me | null
  bootstrap: () => Promise<void>
  loadCurrentUser: () => Promise<void>
  logout: () => Promise<void>
}

export const useSessionStore = create<SessionState>((set, get) => ({
  status: 'idle',
  me: null,
  bootstrap: async () => {
    if (get().status !== 'idle') return
    set({ status: 'loading' })
    try {
      await refreshSession()
      const me = await loadMe()
      set({ status: me ? 'authenticated' : 'anonymous', me })
    } catch {
      set({ status: 'anonymous', me: null })
    }
  },
  loadCurrentUser: async () => {
    const me = await loadMe()
    set({ status: me ? 'authenticated' : 'anonymous', me })
  },
  logout: async () => {
    await logoutSession()
    set({ status: 'anonymous', me: null })
  },
}))
